module.exports = __webpack_public_path__ + "static/media/avatar-placeholder.75245d64.svg";